import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const STUDIO_IMAGE = "https://customer-assets.emergentagent.com/job_podcast-savi-refresh/artifacts/hl7do8xs_20251215_150701-EDIT.jpg";
const VALENCIA_TEXTURE = "https://images.unsplash.com/photo-1693770062913-2106842037ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHx2YWxlbmNpYSUyMGFyY2hpdGVjdHVyZSUyMGRhcmslMjBtb29keXxlbnwwfHx8fDE3ODQ0NzE0OTR8MA&ixlib=rb-4.1.0&q=85";

export const About = () => {
  return (
    <section id="about" className="relative px-5 sm:px-8 lg:px-12 py-14 sm:py-20 md:py-32 overflow-hidden" data-testid="about-section">
      {/* Valencia texture backdrop */}
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none bg-cover bg-center"
        style={{ backgroundImage: `url(${VALENCIA_TEXTURE})` }}
      />

      <div className="relative grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        {/* Image */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="relative group"
        >
          <div className="border border-[#232332] overflow-hidden">
            <img
              src={STUDIO_IMAGE}
              alt="The podcast studio at Savi Coliving"
              className="w-full h-[280px] sm:h-[380px] lg:h-[460px] object-cover img-brutal"
              data-testid="about-main-image"
            />
          </div>
          <p className="font-mono-tcc text-[10px] uppercase tracking-[0.25em] text-[#5E5E72] mt-3">
            Savi Coliving — Mountains of Valencia — 39.6°N, 0.5°W
          </p>
        </motion.div>

        {/* Content */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="min-w-0"
        >
          <p className="overline-tcc mb-4">About the podcast</p>
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl leading-[0.9] text-[#F4F2EE] mb-8 break-words">
            Where real<br />
            conversations <span className="text-stroke-lime">live</span>
          </h2>

          <div className="space-y-5 text-[#9494A6] font-light text-base md:text-lg leading-relaxed max-w-lg">
            <p>
              <strong className="text-[#F4F2EE] font-medium">Truths, Chaos &amp; Cupcakes</strong> started
              the way most good conversations do — around a table, with time, and very little
              intention to behave.
            </p>
            <p>
              No gurus, no life hacks, no five-step frameworks. Just honest conversations about
              life, work, sobriety, community, and the beautiful mess of being human.{" "}
              <span className="font-serif-tcc italic text-[#FF3E8A]">Cake helps.</span>
            </p>
          </div>

          {/* Savi connection */}
          <a
            href="https://savicoliving.com"
            target="_blank"
            rel="noopener noreferrer"
            className="group/savi mt-10 flex items-center justify-between gap-4 border border-[#232332] hover:border-[#FF3E8A] p-6 md:p-8 transition-colors duration-200 max-w-lg"
            data-testid="savi-link"
          >
            <div className="min-w-0">
              <p className="font-mono-tcc text-[10px] uppercase tracking-[0.25em] text-[#9494A6] mb-2">
                A production of
              </p>
              <p className="font-display text-2xl md:text-3xl text-[#F4F2EE] group-hover/savi:text-[#FF3E8A] transition-colors duration-200">
                Savi Coliving
              </p>
              <p className="text-sm text-[#9494A6] font-light mt-1">
                Intentional living in Valencia, Spain
              </p>
            </div>
            <ArrowUpRight size={24} className="text-[#C8FF3E] group-hover/savi:translate-x-1 group-hover/savi:-translate-y-1 transition-transform duration-200 shrink-0" />
          </a>
        </motion.div>
      </div>
    </section>
  );
};
